import { useQuery } from '@tanstack/react-query';
import { PaginationState } from 'app/shared/pagination/pagination.model';
import {
  ChamberMemberOverviewFilterModel
} from 'app/edozvola/chamber-member-overview/model/chamber-member-overview.model';
import {
  fetchChamberMemberOverview
} from 'app/edozvola/chamber-member-overview/service/chamber-member-overview.service';

export const fetchChamberMemberOverviewQuery = (pagination: PaginationState, filterDto: ChamberMemberOverviewFilterModel) => {
  return useQuery({
    queryKey: ['chamber-member-overview', { ...pagination }, {...filterDto}],
    queryFn: () => fetchChamberMemberOverview(pagination, filterDto)
  });
};
